<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <s3-configuration-form v-model="config" :readonly="!editMode" :mode="mode"></s3-configuration-form>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'create' && demo">
            <b-button v-if="mode === 'create'"
              @click="createConfig" variant="primary">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canEditConfig && demo">
            <b-button variant="primary"
              @click="editModeActivate">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('administration.edit') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canDeleteConfig && demo">
            <b-button variant="primary"
              @click="deleteConfig">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('rights.delete') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === true && demo">
            <b-button variant="primary"
              @click="editConfig">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import S3ConfigurationForm from '@/pages/routing/S3ConfigurationForm.vue'
import moment from "moment/moment"

import {loadPage} from '@/helpers/routing'


export default {
  name: 'S3ConfigurationDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    's3-configuration-form': S3ConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    entitiesType: {
      type: String,
      default: "rvm"
    },
    msgType: {
      type: String,
    },
    IdConfigRouting: {
      type: String,
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('s3config_delete', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('s3_config_edit', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.s3_details') : this.$t('Webheader.s3_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      demo: true,
      editMode: false,
      returnUrl: '',
      // returnUrl: this.entitiesType === 'rvm' ? '/entitiessettings/rvm/BICRVM' : `/entitiessettings/${this.entitiesType}/Corporate`,
      savedConfig: []
    }
  },
  created () {
    this.role = this.$route.query.role
    this.type = this.$route.query.type
    this.returnUrl = `/routing/configS3list/${this.msgType}/${this.entitiesType}`
    this.activateSpinner = true

    if (this.mode === 'details') {
      this.savedConfig = this.$engine.routing.config.clickedConfig
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === '1') {
        let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: 'SSL',
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          deliveredBy: this.config.certificateConfig.deliveredBy,
          deliveredTo: this.config.certificateConfig.deliveredTo,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host
            params.Port = that.config.port
            params.URI = that.config.uri
            params.SSLMode = that.config.sslActive
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            params.proxyActive = that.config.proxyActive

            if (that.config.proxyActive){
              params.proxyHost = that.config.proxyHost
              params.proxyPort = that.config.proxyPort
              params.proxyLogin = that.config.proxyLogin
              params.proxyPwd = that.config.proxyPwd
              params.proxyTunnel = that.config.proxyTunnel
              params.proxyConnectOnly = that.config.proxyConnectOnly
            }



            that.$engine.routing.config.s3.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: this.returnUrl})
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }

        params.proxyActive = that.config.proxyActive

        if (that.config.proxyActive) {
          params.proxyHost = that.config.proxyHost
          params.proxyPort = that.config.proxyPort
          params.proxyLogin = that.config.proxyLogin
          params.proxyPwd = that.config.proxyPwd
          params.proxyTunnel = that.config.proxyTunnel
          params.proxyConnectOnly = that.config.proxyConnectOnly
        }

        this.$engine.routing.config.s3.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/S3/1'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdS3: that.savedConfig.IdS3
              }
              that.$engine.routing.config.s3.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }
      let params = {
        Port: this.config.Port,
        URI: this.config.URI,
        IdS3: this.savedConfig.IdConfigS3,
        Region: this.config.Region,
        AccessKey: this.config.AccessKey,
        SecretKey: this.config.SecretKey,
        BucketName: this.config.BucketName,
        Prefix: this.config.Prefix,
        MinBufferSize: this.config.MinBufferSize,
        MaxBufferSize: this.config.MaxBufferSize,
        BeginDate: this.savedConfig.Role == 0 ? undefined : moment(this.config.BeginDate, "DD/MM/YYYY H:mm:ss").utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
        proxyActive: this.config.proxyActive,
        ForceReOpen: this.config.ForceReOpen,
        Scheme: this.config.Scheme,
        useDualStack: this.config.useDualStack,
        maxConnections: this.config.maxConnections,
        RequestTimeoutMs: this.config.RequestTimeoutMs,
        ConnectTimeoutMs: this.config.ConnectTimeoutMs,
        enableTcpKeepAlive: this.config.enableTcpKeepAlive,
        tcpKeepAliveInvervalMs: this.config.tcpKeepAliveInvervalMs,
        lowSpeedLimit: this.config.lowSpeedLimit,
        VerifySSL: this.config.VerifySSL,
        FollowRedirects: this.config.FollowRedirects,
        DisableExpectHeader: this.config.DisableExpectHeader,
        EnableClockSkewAdjustement: this.config.EnableClockSkewAdjustement,
        enableHostPrefixInfection: this.config.enableHostPrefixInfection,
        enableEndpointdiscovery: this.config.enableEndpointdiscovery,
        caPath: this.config.caPath,
        caFile: this.config.caFile,
      }

      if (that.config.proxyActive){
        params.proxyScheme = that.config.proxyScheme
        params.proxyPort = that.config.proxyPort
        params.proxyLogin = that.config.proxyLogin
        params.proxyPwd = that.config.proxyPwd
        params.proxyHost = that.config.proxyHost
      }
      console.log(that.config)
      this.$engine.routing.config.s3.edit(params)
          .then(resp => {
            that.$f7.modal({
              title: this.$t('common.routing.config_edited'),
              buttons: [
                {
                  text: 'OK',
                  onClick: function () {
                    return
                  }
                }
              ]
            })
            loadPage(that, {url: this.returnUrl})
          })
          .catch(e => {
            errorMessageAlert(e, that)
            this.okMessageBox(this.$t('common.routing.config_edition_error'))
          })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.ConfigName = this.savedConfig.ConfigName
      this.config.AccessKey = this.savedConfig.AccessKey
      this.config.BeginDate = this.savedConfig.BeginDate
      this.config.BucketName = this.savedConfig.BucketName
      this.config.BeginDate = moment(this.savedConfig.BeginDate).format("DD/MM/YYYY H:mm:ss") == 'Invalid date'? '':moment(this.savedConfig.BeginDate).format("DD/MM/YYYY H:mm:ss")
      this.config.EndDate = moment(this.savedConfig.EndDate).format("DD/MM/YYYY H:mm:ss") == 'Invalid date'? '':moment(this.savedConfig.EndDate).format("DD/MM/YYYY H:mm:ss")
      this.config.IdS3 = this.savedConfig.IdConfigS3
      this.config.OnlyFile = this.savedConfig.OnlyFile
      this.config.Port = this.savedConfig.Port
      this.config.Prefix = this.savedConfig.Prefix
      this.config.Region = this.savedConfig.Region
      this.config.SecretKey = this.savedConfig.SecretKey
      this.config.URI = this.savedConfig.URI
      this.config.MinBufferSize = this.savedConfig.MinBufferSize
      this.config.MaxBufferSize = this.savedConfig.MaxBufferSize
      this.config.Role = this.savedConfig.Role
      this.config.proxyActive = this.savedConfig.proxyActive
      this.config.proxyScheme = this.savedConfig.proxyScheme
      this.config.proxyPort = this.savedConfig.proxyPort
      this.config.proxyLogin = this.savedConfig.proxyLogin
      this.config.proxyPwd = this.savedConfig.proxyPwd
      this.config.proxyHost = this.savedConfig.proxyHost
      this.config.ForceReOpen = this.savedConfig.ForceReOpen
      this.config.Scheme = this.savedConfig.Scheme
      this.config.useDualStack = this.savedConfig.useDualStack
      this.config.maxConnections = this.savedConfig.maxConnections
      this.config.RequestTimeoutMs = this.savedConfig.RequestTimeoutMs
      this.config.ConnectTimeoutMs = this.savedConfig.ConnectTimeoutMs
      this.config.enableTcpKeepAlive = this.savedConfig.enableTcpKeepAlive
      this.config.tcpKeepAliveInvervalMs = this.savedConfig.tcpKeepAliveInvervalMs
      this.config.lowSpeedLimit = this.savedConfig.lowSpeedLimit
      this.config.VerifySSL = this.savedConfig.VerifySSL
      this.config.FollowRedirects = this.savedConfig.FollowRedirects
      this.config.DisableExpectHeader = this.savedConfig.DisableExpectHeader
      this.config.EnableClockSkewAdjustement = this.savedConfig.EnableClockSkewAdjustement
      this.config.enableHostPrefixInfection = this.savedConfig.enableHostPrefixInfection
      this.config.enableEndpointdiscovery = this.savedConfig.enableEndpointdiscovery
      this.config.caPath = this.savedConfig.caPath
      this.config.caFile = this.savedConfig.caFile
    },
    formHasError () {
      if (this.config.BucketName === undefined || this.config.BucketName.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_bucket_name_missing'))
        return true
      }
      if (this.config.URI === undefined || this.config.URI.length === 0) {
        this.okMessageBox(this.$t('common.routing.uri_missing'))
        return true
      }
      if (this.config.Port === undefined || this.config.Port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: this.returnUrl})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
